import request from '../../base-service';
import { InternalAxiosRequestConfig } from 'axios';
import type { ActionPlanApiRequestOptions } from '@/configs/actionPlanV2ApiOrigin';
import { BaoCaoDuAnCongViecBatchRequest, BaoCaoDuAnCongViecView } from '@/types/action-plan/ActionPlan/BaoCaoDuAnCongViecView';
import { ImportCongViecRequest, RequestDTO } from '@/types/requestDTO';
import { ApiResponse } from '@/types/base';
const baseUrl = '/v1';
// const baseUrl = '/v1';
export const baocaoApi = {
  savebaocao: (model: BaoCaoDuAnCongViecView, options?: ActionPlanApiRequestOptions) => {
    return request.post(`${baseUrl}/baocaocongviec/savebaocao`, model, {
      ...options,
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  /** V2: như savebaocao + ghi thời điểm báo cáo (cột Hoàn thành đúng / quá hạn — EmployeeHome V2). */
  savebaocaov2: (model: BaoCaoDuAnCongViecView, options?: ActionPlanApiRequestOptions) => {
    return request.post(`${baseUrl}/baocaocongviec/savebaocaov2`, model, {
      ...options,
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  savebaocaobatch: (model: BaoCaoDuAnCongViecBatchRequest, options?: ActionPlanApiRequestOptions) => {
    return request.post(`${baseUrl}/baocaocongviec/savebaocaobatch`, model, {
      ...options,
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  getbaocao: (model: RequestDTO) => {
    return request.post(`${baseUrl}/baocaocongviec/getbaocao`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  gettablechiachitieu: (model: unknown) => {
    return request.post(`${baseUrl}/baocaocongviec/gettablechiachitieu`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },

  /** Lưu bảng chia chi tiết (listTanSuat + công việc sau khi chia chỉ tiêu) — SaveTableChiachitiet */
  saveTableChiachitiet: (model: BaoCaoDuAnCongViecView) => {
    return request.post(`${baseUrl}/baocaocongviec/savetablechiachitiet`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  /**
   * Thảo luận (discussion) theo công việc
   */
  loadThaoLuan: (payload: { id: string; phanHe: string }) => {
    // POST /api/v1/BaoCaoCongViec/loadthaoluan
    return request.post(`${baseUrl}/baocaocongviec/loadthaoluan`, payload, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  saveThaoLuan: (formData: FormData) => {
    // POST /api/v1/BaoCaoCongViec/savethaoluan (multipart/form-data)
    return request.post(`${baseUrl}/baocaocongviec/savethaoluan`, formData, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
   /** POST: import công việc. [FromForm] ImportCongViecRequest. */
   importbaocaonhanh: (model: ImportCongViecRequest) => {
    const formData = new FormData();
    formData.append('PhanHe', model.PhanHe ?? '');
    formData.append('IDBoPhan', String(model.IDBoPhan ?? 0));
    formData.append('IDMucTieu', model.IDMucTieu ?? '');
    formData.append('IDDuAn', model.IDDuAn ?? '');
    formData.append('SelectBophan', model.SelectBophan ?? '');
    formData.append('Year', String(model.Year ?? new Date().getFullYear()));
    if (model.File) formData.append('File', model.File);
    return request.post<ApiResponse<Blob>>(`${baseUrl}/baocaocongviec/importbaocaonhanh`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
};
